import * as actions from '@/nebula/actions';
import { useStore } from 'vuex';

export default function useBulkMutate() {
  const store = useStore();
  const bulkMutate = (payloads) => actions.bulkMutate(store, payloads);

  return { bulkMutate };
}
